import { getCompanyId } from './api';

const companyId = getCompanyId();

export const BackEndRoutes = {
  PUBLIC: {
    SITE_CONFIG: `/public/companies/${companyId}/site-config`,
    TEAM: `/public/companies/${companyId}/team`,
    SERVICE_GROUPS: `/public/companies/${companyId}/service-groups`,
    PAGES: `/public/companies/${companyId}/pages`,
    GALLERY: `/public/companies/${companyId}/gallery`,
    CONTACT: `/public/companies/${companyId}/contact`,
  },
};
